// apps/patient/src/components/appointments/ManageWindowNotice.tsx

import { AlertTriangle } from 'lucide-react';

interface ManageWindowNoticeProps {
  windowHours: number;
  phone?: string | null;
}

export function ManageWindowNotice({ windowHours, phone }: ManageWindowNoticeProps) {
  return (
    <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
      <div className="flex items-start gap-3">
        <AlertTriangle className="h-5 w-5 text-yellow-600 mt-0.5 flex-shrink-0" />
        <p className="text-sm text-yellow-800">
          {windowHours > 0
            ? `Changes within ${windowHours} hours of your appointment must be made by phone.`
            : 'This appointment can no longer be changed online.'}{' '}
          {phone ? (
            <>
              Please call the office at{' '}
              <a href={`tel:${phone}`} className="underline text-yellow-900 font-medium">{phone}</a>.
            </>
          ) : (
            'Please call the office.'
          )}
        </p>
      </div>
    </div>
  );
}
